import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from 'antd';

export const Route = createFileRoute('/')({
  component: App,
});

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Welcome to community manager App</p>
        <Link to={'/login'}>
          <Button variant="filled">Login</Button>
        </Link>
      </header>
    </div>
  );
}
